<template>
  <div class="dialog-wrap">
    <el-dialog title="题库组合创建"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="题库名称"
                      prop="name">
          <el-input v-model="dataForm.name"
                    placeholder="请输入题库名称"></el-input>
        </el-form-item>
        <el-form-item label="关联专业"
                      prop="majors">
          <div class="tag-wrap">
            <el-tag size="medium"
                    :key="item.id"
                    v-for="item in majors"
                    closable
                    :disable-transitions="false"
                    @close="handleMajorRemove(item)">
              {{ `${item.name}/${item.code}` }}
            </el-tag>
            <el-button type="text"
                       @click="handleMajorChoose">选择专业</el-button>
          </div>
        </el-form-item>
        <el-form-item label="关联科目："
                      prop="subjects">
          <div class="tag-wrap">
            <el-tag size="medium"
                    :key="item.id"
                    v-for="item in subjects"
                    closable
                    :disable-transitions="false"
                    @close="handleSubjectRemove(item)">
              {{
                  item.college_name
                    ? `${item.college_name}-${item.name}`
                    : item.name
                }}
            </el-tag>
            <el-button type="text"
                       @click="handleSubjectChoose">选择科目</el-button>
          </div>
        </el-form-item>
        <el-form-item label="会员商品："
                      prop="product_id">
          <div class="tag-wrap">
            <el-tag size="medium"
                    closable
                    :disable-transitions="false"
                    @close="handleProductRemove(item)"
                    v-if="product">
              {{product.name}}
            </el-tag>
            <el-button type="text"
                       v-if="!product"
                       @click="goodsChooseDialog=true">选择商品</el-button>
          </div>
        </el-form-item>
        <el-form-item label="在线状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>

    <GoodsTabsChooseJoint :visible="goodsChooseDialog"
                          type="single"
                          @close="goodsChooseDialog = false"
                          @submit="saveGoods"
                          :chooseable="false"
                          :isAll="isAll" />
  </div>
</template>

<script>
import { examComposeCreate } from '@/api/exam'
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import GoodsTabsChooseJoint from '@/components/dialog/product/GoodsTabsChooseJoint'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SubjectChoose,
    MajorChoose,
    GoodsTabsChooseJoint,
  },
  data() {
    return {
      isAll: 1,
      major: null,
      majorChooseDialog: false,
      subjectChooseDialog: false,
      goodsChooseDialog: false,
      subjects: [],
      majors: [],
      product: null,
      dialogVisible: this.visible,
      dataForm: {},
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入组合名称', trigger: 'blur' }],
        product_id: [
          {
            required: true,
            message: '请选择商品',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!this.product) {
                return callback(new Error(rule.message))
              } else {
                callback()
              }
            },
          },
        ],
        status: [
          { required: false, message: '请设置上线状态', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
      console.log('majors', majors)
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
      console.log(this.subjects, '科目')
    },
    saveGoods(product) {
      if (product) {
        this.product = product
      }
    },
    handleProductRemove() {
      this.product = null
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            status: this.dataForm.status ? 1 : 0,
            unlock_product_id: this.product.id,
            arr_major_info: this.majors,
            arr_subject_info: this.subjects,
          })
          examComposeCreate(params)
            .then((res) => {
              this.$message.success(`添加成功`)
              this.$refs['dataForm'].resetFields()
              ;(this.major = null), (this.subjects = []), this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
